import { URL_ENDPOINTS } from "../../constants";
import Api from "../../api/api-helper";
import { DebtResponse } from "../../interfaces/Debt";
import { LoanResponse, PaymentMethods } from "../../interfaces/Loan";
import {
  PaymentDataRequest,
  PaymentDataResponse,
  ReusePaymentRequest,
  ReusePaymentResponse,
} from "../../interfaces/Payment";
import { ClickToCallRequest, LedgersRequest, LedgersResponse, UserResponse } from "../../interfaces/UserData";
import { PaymentPlanParams, SimulationResponse } from "../../interfaces/PaymentPlan";

const FinancialService = {
  getDebtData: async (identification: string): Promise<DebtResponse> => {
    
    return await Api.POST(URL_ENDPOINTS.FINANCIAL + "/debt/searches", {
      document_id: identification,
    });
  },
  getLoans: async (): Promise<{loans: LoanResponse[]}> => {
    return await Api.POST(URL_ENDPOINTS.FINANCIAL + `/loans/searches`, {});
  },
  getLoanData: async (loanId: string): Promise<LoanResponse> => {
    return await Api.GET(URL_ENDPOINTS.FINANCIAL + `/loans/${loanId}`);
  },
  getPaymentCards: async (identification: string): Promise<PaymentMethods> => {
    return await Api.POST(
      URL_ENDPOINTS.FINANCIAL + `/payment-methods/searches`,
      {
        document_id: identification,
      }
    );
  },
  patchPaymentData: async (loanId: string, paymentMethodId: string): Promise<PaymentDataResponse> => {
    return await Api.PATCH(URL_ENDPOINTS.FINANCIAL + `/loans/${loanId}/payment-data`, {
      payment_method_id: paymentMethodId
    });
  },
  createPayment: async (
    data: PaymentDataRequest
  ): Promise<PaymentDataResponse> => {
    return await Api.POST(URL_ENDPOINTS.FINANCIAL + `/payments`, data);
  },
  reusePayment: async (
    data: ReusePaymentRequest
  ): Promise<ReusePaymentResponse> => {
    return await Api.POST(URL_ENDPOINTS.FINANCIAL + `/reuse-payment`, data);
  },
  getUserData: async (): Promise<UserResponse> => {
    return await Api.GET(URL_ENDPOINTS.FINANCIAL + `/me/customers`);
  },
  clickToCall: async (data: ClickToCallRequest): Promise<UserResponse> => {
    return await Api.POST(URL_ENDPOINTS.FINANCIAL + `/clicktocall`, data);
  },
  searchLedgers: async (data: LedgersRequest): Promise<LedgersResponse> => {
    return await Api.POST(URL_ENDPOINTS.FINANCIAL + `/ledgers/searches`, data)
  },
  simulatePaymentPlan: async (loanId: string): Promise<SimulationResponse> => {
    return await Api.GET(URL_ENDPOINTS.FINANCIAL + `/loans/${loanId}/simulation-payment-plan`);
  },
  createPaymentPlan: async (data: PaymentPlanParams): Promise<LoanResponse> => {
    return await Api.POST(URL_ENDPOINTS.FINANCIAL + `/loans/${data.loan_id}/payment-plan`, data);
  },
};

export default FinancialService;
